import _objectWithoutProperties from "/apps/packages/ui/node_modules/gatsby/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["id", "label", "error", "action", "helpText", "children", "labelHidden", "requiredIndicator"];
import React from 'react';
import { classNames } from '../../utilities/css.js';
import styles from './Labelled.scss.js';
import { InlineError } from '../InlineError/InlineError.js';
import { Label } from '../Label/Label.js';
export { labelID } from '../Label/Label.js';
import { buttonFrom } from '../Button/utils.js';

function Labelled(_ref) {
  var id = _ref.id,
      label = _ref.label,
      error = _ref.error,
      action = _ref.action,
      helpText = _ref.helpText,
      children = _ref.children,
      labelHidden = _ref.labelHidden,
      requiredIndicator = _ref.requiredIndicator,
      rest = _objectWithoutProperties(_ref, _excluded);

  var className = classNames(labelHidden && styles.hidden);
  var actionMarkup = action ? /*#__PURE__*/React.createElement("div", {
    className: styles.Action
  }, buttonFrom(action, {
    plain: true
  })) : null;
  var helpTextMarkup = helpText ? /*#__PURE__*/React.createElement("div", {
    className: styles.HelpText,
    id: helpTextID(id)
  }, helpText) : null;
  var errorMarkup = error && typeof error !== 'boolean' && /*#__PURE__*/React.createElement("div", {
    className: styles.Error
  }, /*#__PURE__*/React.createElement(InlineError, {
    message: error,
    fieldID: id
  }));
  var labelMarkup = label ? /*#__PURE__*/React.createElement("div", {
    className: styles.LabelWrapper
  }, /*#__PURE__*/React.createElement(Label, Object.assign({
    id: id,
    requiredIndicator: requiredIndicator
  }, rest, {
    hidden: false
  }), label), actionMarkup) : null;
  return /*#__PURE__*/React.createElement("div", {
    className: className
  }, labelMarkup, children, errorMarkup, helpTextMarkup);
}

function helpTextID(id) {
  return "".concat(id, "HelpText");
}

export { Labelled, helpTextID };